import script from "./LoginView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginView.vue?vue&type=script&setup=true&lang=ts"

import "./LoginView.vue?vue&type=style&index=0&id=5bfe05ca&lang=scss&scoped=true"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bfe05ca"]])

export default __exports__